import store from 'store'
import PhaseActions from 'store/redux/phase'

export default socket => {
    socket.on('request_selection', response => {
        console.tron.log('SOCKET RECEIVED - request_selection:')
        console.tron.log(response)
        store.dispatch(PhaseActions.endPhase())
    })
}



// WEBPACK FOOTER //
// src/api/listeners/selection.js